import { DtoMessageEnum } from '@zaoblako/shared/common/enums/dto.message.enum';
import * as yup from 'yup'

/** Common validation schema for any non-empty string */
export const nonEmptyStringSchema = yup
  .string()
  .min(1, DtoMessageEnum.EMPTY_STRING);
